import { render } from "./Navs.vue?vue&type=template&id=2b6814e8&scoped=true"
import script from "./Navs.vue?vue&type=script&lang=js"
export * from "./Navs.vue?vue&type=script&lang=js"

import "./Navs.vue?vue&type=style&index=0&id=2b6814e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6814e8"]])

export default __exports__